export default "Escape Room Roskilde opened in June 2020.";